// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__3aB05","topBottomGutter":"Layout_topBottomGutter__2L8a7"};